'use client'

import { type FC, useContext } from 'react'

import { LoginRegistrationOneTimePasswordInputForm } from '../../../login-registration/components/LoginRegistrationOneTimePasswordInputForm/LoginRegistrationOneTimePasswordInputForm'
import {
  LOGIN_OTP_STATE,
  LoginRegistrationUserLoginStateContext,
} from '../../../login-registration/context/LoginRegistrationUserLoginStateContext'
import { type LoginAfterLoggedIn } from '../../../login-registration/loginAfterLoggedIn'
import { useTwoStepLoginOtpTracking } from '../twoStepLoginOtpTracking'

interface LoginRegistrationUserOneTimePasswordInputFormProps {
  afterLoggedIn?: LoginAfterLoggedIn
}

export const LoginRegistrationUserOneTimePasswordInputForm: FC<
  LoginRegistrationUserOneTimePasswordInputFormProps
> = ({ afterLoggedIn }) => {
  const { setLoginOtpState } = useContext(
    LoginRegistrationUserLoginStateContext,
  )
  const tracking = useTwoStepLoginOtpTracking()

  return (
    <LoginRegistrationOneTimePasswordInputForm
      afterLoggedIn={afterLoggedIn}
      onAcceptedSubmit={() => {
        tracking.track('submit')
      }}
      onBackToPassword={() => {
        tracking.track('switch_to_password')
        setLoginOtpState(LOGIN_OTP_STATE.PASSWORD_INPUT)
      }}
      onChangeEmail={() => {
        setLoginOtpState(LOGIN_OTP_STATE.LOGIN_REGISTER)
      }}
      onSubmissionFailure={() => {
        tracking.track('failure')
      }}
    />
  )
}
